// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1X9X_","name":"Header_name__3gOo_","birthday":"Header_birthday__2KPHw","skeleton":"Header_skeleton__2Y_qG"};